<template>
  <div class="website-container">
    <Header-list ref="header"/>
    <div>
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"></router-view>
      </keep-alive>
    </div>
    <Footer-list ref="footer"/>
  </div>
</template>

<script>
import HeaderList from './components/header/index.vue'
import FooterList from './components/footer/index.vue'
export default {
  name: 'LayOut',
  components: {
    FooterList,
    HeaderList
  }
}
</script>

<style lang="less">
.website-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #ffffff;

  // Ensure content takes up remaining space
  > div:nth-child(2) {
    flex: 1;
  }
}
</style>
